import { render, staticRenderFns } from "./AppHeader2.vue?vue&type=template&id=7461d646"
import script from "./AppHeader2.vue?vue&type=script&lang=ts"
export * from "./AppHeader2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports